import { createCheckoutContext, isPickupShipping } from './context.js'
import { normalizePointType } from '../dhlPickupPointMap.js'
import { normalizePickupPoint, pickupPointIdentifier, requiresGermanPostnummer } from './pickupPoint.js'

export const PICKUP_VALIDATION_CODES = Object.freeze({
  VALID: 'VALID',
  CONFIG_MISSING_FIELD: 'CONFIG_MISSING_FIELD',
  STATE_PENDING: 'STATE_PENDING',
  POINT_REQUIRED: 'POINT_REQUIRED',
  POINT_TYPE_REQUIRED: 'POINT_TYPE_REQUIRED',
  POSTNUMMER_REQUIRED: 'POSTNUMMER_REQUIRED',
  PERSISTENCE_UNCONFIRMED: 'PERSISTENCE_UNCONFIRMED',
})

function result(valid, code) {
  return { valid, code }
}

export function validatePickupPoint({ settings, context, snapshot, persistence = 'cache', fieldAvailable = true } = {}) {
  const checkoutContext = createCheckoutContext(context)
  if (checkoutContext.shippingId === null) {
    return result(false, PICKUP_VALIDATION_CODES.STATE_PENDING)
  }
  if (!isPickupShipping(settings, checkoutContext.shippingId)) {
    return result(true, PICKUP_VALIDATION_CODES.VALID)
  }
  if (!checkoutContext.countryIso || !checkoutContext.paymentType) {
    return result(false, PICKUP_VALIDATION_CODES.STATE_PENDING)
  }
  if (!settings?.pickupPointFieldId || !fieldAvailable) {
    return result(false, PICKUP_VALIDATION_CODES.CONFIG_MISSING_FIELD)
  }

  const point = normalizePickupPoint(snapshot)
  if (!point || pickupPointIdentifier(point) === '') {
    return result(false, PICKUP_VALIDATION_CODES.POINT_REQUIRED)
  }
  if (checkoutContext.countryIso === 'DE' && !['packStation', 'parcelShop'].includes(normalizePointType(point.type))) {
    return result(false, PICKUP_VALIDATION_CODES.POINT_TYPE_REQUIRED)
  }
  if (requiresGermanPostnummer(point, checkoutContext.countryIso) && String(point.postnummer ?? '').trim() === '') {
    return result(false, PICKUP_VALIDATION_CODES.POSTNUMMER_REQUIRED)
  }
  if (checkoutContext.stage === 'summary' && persistence !== 'persisted') {
    return result(false, PICKUP_VALIDATION_CODES.PERSISTENCE_UNCONFIRMED)
  }

  return result(true, PICKUP_VALIDATION_CODES.VALID)
}
